// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchSection_container__1d3Ut","sectionItem":"SearchSection_sectionItem__tDaZa","emptyContainer":"SearchSection_emptyContainer__1XPKT"};